<div class="parts-information">
  <!-- Global tooltip for notes (rendered outside scroll container so it is not clipped) -->
  <div
    class="notes-tooltip-global"
    *ngIf="notesTooltipPartIndex !== null"
    [style.left.px]="notesTooltipPosition.left"
    [style.top.px]="notesTooltipPosition.top">
    Click to open notes in full view
  </div>

  <!-- Initial View - Quote Summary with Add Part Button -->
  <div class="quote-summary-view">
    <div class="quote-summary-header">
      <h2>Quote Summary</h2>
    </div>

    <!-- Quote Information Display -->
    <div class="quote-info-section">
      <div class="quote-info-grid">
        <!-- Company Details Column -->
        <div class="company-details-row">
          <div class="info-field input-width">
            <input class="text-truncate" type="text" 
                   [value]="quoteDetails.companyName || ''"
                   placeholder="Enter Company Name"
                   readonly>
          </div>
          <div class="info-field input-width-term">
            <label>Quote #</label>
            <input type="text" 
                   [value]="quoteDetails.quoteNumber || ''"
                   placeholder="Enter Quote Number" 
                   readonly>
          </div>
          <div class="info-field">
            <label>Quote Date</label>
            <label>{{quoteDetails.quoteDate | date:'MM/dd/yyyy'}}</label>            
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-width">
                   <div class="tooltip-container">
                    <input class="text-truncate" type="email" [value]="quoteDetails.companyEmail"
                      placeholder="enter company email" readonly>
                    <div class="tooltip-popup">
                       {{quoteDetails.companyEmail}}
                    </div>
                </div>
          </div>
          <div class="info-field input-width-term">
            <label>Payment Terms</label>
            <input class="text-truncate" type="text"
                   [value]="quoteDetails.paymentTerm || ''"
                   placeholder="Select Payment Term" 
                   readonly>
          </div>
          <div class="info-field">
            <label>Valid Until</label>
            <label>{{quoteDetails.quoteExpiryDate | date:'MM/dd/yyyy'}}</label>
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-width">
            <input type="tel" 
                   [value]="quoteDetails.companyPhone || ''"
                   placeholder="Enter Phone Number" 
                   readonly>
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-full-width">
            <input type="text" 
                   [value]="quoteDetails.address || ''"
                   placeholder="Address" 
                   readonly>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Parts Pricing Display -->
  <div class="parts-pricing-container" *ngIf="parts && parts.length > 0">
    <div class="part-container" *ngFor="let part of parts; let i = index; trackBy: trackByPartIndex">
      <div class="part-header">
        <span class="part-title">{{ part.partName || 'Add Part Name' }}</span>
        <div class="part-header-right">
          <span class="part-title">{{ part.partNumber || 'Add Part Number' }}</span>
          <button class="edit-btn" 
            [class.btn-quote]="!part.isPartDetailCompleted"
            (click)="onEditPart(i)">
            {{ part.isPartDetailCompleted ? 'Edit' : 'Quote' }}</button>
        </div>
      </div>
    
      <div class="part-body" *ngIf="part.isPartDetailCompleted">
        <div class="part-table" *ngIf="part.quantityPricing && part.quantityPricing.length > 0">
          <table>
            <thead>
              <tr>
                <th class="quantity-header">Quantity</th>
                <th class="leadtime-header">Leadtime</th>
                <th class="unit-price-header">Unit Price</th>
                <th class="total-header">Total</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let pricing of part.quantityPricing; trackBy: trackByPricingIndex; let i = index">
                <tr *ngIf="i < 3">
                  <td>{{ pricing.quantity && pricing.quantity > 0 ? pricing.quantity : '--' }}</td>
                  <td>{{ pricing.quantity && pricing.quantity > 0 && pricing.leadtimeValue ? pricing.leadtimeValue + ' ' + pricing.leadtimeUnit : '--' }}</td>
                  <td class="text-right">{{ pricing.quantity && pricing.quantity > 0 ? (pricing.unitPrice | formatNumber:true) : '--' }}</td>
                  <td class="text-right">{{ pricing.quantity && pricing.quantity > 0 ? (pricing.total | formatNumber:true) : '--' }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        
        <div class="no-data-message" *ngIf="!part.quantityPricing || part.quantityPricing.length === 0">
          <p>No pricing data available for this part.</p>
        </div>

        <div class="buyer-notes-panel">
          <div class="buyer-notes-toggle">
            <span>Notes to Buyer</span>
            <div class="buyer-notes-header-actions">
              <button
                type="button"
                class="notes-popup-link"
                (mouseenter)="showNotesTooltip(i, $event)"
                (mouseleave)="hideNotesTooltip()"
                (click)="openBuyerNotesModal(i)">
                <img
                  src="assets/img/svg/expand-full-screen-icon.svg"
                  alt="Open notes in full view">
              </button>
              <button
                type="button"
                class="buyer-notes-collapse-toggle"
                (click)="toggleBuyerNotes(i)">
                {{ isBuyerNotesExpanded(i) ? '-' : '+' }}
              </button>
            </div>
          </div>

          <div class="buyer-notes" *ngIf="isBuyerNotesExpanded(i)">
            <textarea 
              id="notes-{{i}}" 
              name="notes-{{i}}"
              [attr.maxlength]="buyerNotesMaxLength"
              [ngModel]="part.notesForBuyer || ''"
              (ngModelChange)="onBuyerNotesChange(i, $event)"
              [class.error-border]="getBuyerNotesError(i)"
              rows="3"></textarea>
            <div class="notes-footer">
              <span class="char-count" [class.error-text]="getBuyerNotesError(i)">
                {{(part.notesForBuyer || '').length}}/{{ buyerNotesMaxLength }}
              </span>
            </div>
            <div class="error-message" *ngIf="getBuyerNotesError(i)">
              {{ getBuyerNotesError(i) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Buyer Notes Full View Modal -->
  <div class="buyer-notes-modal-overlay" *ngIf="activeBuyerNotesIndex !== null">
    <div class="buyer-notes-modal">
      <div class="buyer-notes-modal-header">
        <h3>Notes to Buyer</h3>
        <button
          type="button"
          class="buyer-notes-modal-close"
          (click)="closeBuyerNotesModal()">
          ×
        </button>
      </div>
      <div class="buyer-notes-modal-body" *ngIf="activeBuyerNotesIndex !== null">
        <textarea
          [attr.maxlength]="buyerNotesMaxLength"
          [ngModel]="parts[activeBuyerNotesIndex]?.notesForBuyer || ''"
          (ngModelChange)="onBuyerNotesChange(activeBuyerNotesIndex, $event)"
          rows="8">
        </textarea>
        <div class="notes-footer">
          <span class="char-count">
            {{ (parts[activeBuyerNotesIndex]?.notesForBuyer || '').length }}/{{ buyerNotesMaxLength }}
          </span>
        </div>
      </div>
    </div>
  </div>
  
  <div class="no-data-message" *ngIf="!parts || parts.length === 0 && !isQuoteSubmitted">
    <p>No parts pricing data available.</p>
  </div>

  <!-- Success Message Component -->
  <app-quote-success-message
    *ngIf="isQuoteSubmitted && showSuccessMessage"
    [successData]="successMessageData">
  </app-quote-success-message>
  
  </div>